import React, { Fragment } from 'react';
import PRZLottieT from '@Components/Common/UI/PRZLottieT';
import './style.scss';
import Helpers from '@Apis/helpers';

const RestrictedForm = ({ moduleName }) => {
  const fixedMenuBar = JSON.parse(localStorage.getItem('user_menu_config')) === 'FIXED';
  return (
    <Fragment>
      <div className={`restricted-form__wrapper ${fixedMenuBar ? 'restricted-fixed' : 'restricted-collapsible'}`}>
        <div className="restricted-form-overlay">
          <div className="restricted-form-content__wrapper">
            <div className="restricted-form-content">
              <div className="restricted-form-lock__wrapper">
                <div className="restricted-form-lock">
                  <PRZLottieT
                    file={'restrictedLock.json'}
                  />
                </div>
              </div>
              <div className="restricted-form-text__wrapper">
                <div className="restricted-form-text-head">Premium Feature</div>
                <div className="restricted-form-text-body">{moduleName} feature is not available in your current plan.</div>
              </div>
              <div className="restricted-form-contact-button__wrapper">
                <a>
                  <div
                    className="restricted-form-contact-button"
                    onClick={() => { Helpers.openNewConversationForPremiumFeature(moduleName) }}
                  >
                    Contact Us
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}


export default RestrictedForm
